<div
    #editorRef
    class="observacao-editor-content"
    role="textbox"
    aria-multiline="true"
    [attr.contenteditable]="disabled ? 'false' : 'true'"
    [attr.tabindex]="disabled ? -1 : 0"
    [attr.aria-disabled]="disabled"
    [attr.aria-describedby]="describedByIds.join(' ') || null"
    [attr.aria-placeholder]="placeholder"
    [attr.data-placeholder]="placeholder"
    [style.min-height.em]="rows * 1.1"
    (focus)="onFocus()"
    (blur)="onBlur()"
    (input)="onInput()"
    (keydown)="onKeydown($event)"
    (keyup)="saveSelection()"
    (mouseup)="saveSelection()"
    (paste)="onPaste($event)">
</div>
